import React, { useState } from 'react';

// Icons
const ChevronIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

interface CollapsibleSectionProps {
  title: string;
  count?: number;
  icon?: React.ReactNode;
  variant?: 'default' | 'critical' | 'warning';
  defaultCollapsed?: boolean;
  children: React.ReactNode;
  filterTabs?: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  count,
  icon,
  variant = 'default',
  defaultCollapsed = false,
  children,
  filterTabs,
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  const sectionClasses = [
    'section',
    variant,
    collapsed ? 'collapsed' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={sectionClasses}>
      <div 
        className="section-header"
        onClick={() => setCollapsed(!collapsed)}
        role="button"
        tabIndex={0}
        aria-expanded={!collapsed}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setCollapsed(!collapsed);
          }
        }}
      >
        <div className="section-header-left">
          {icon && <span className="section-icon">{icon}</span>}
          <h2>
            {title}
            {count !== undefined && count > 0 && (
              <span className="section-count">{count}</span>
            )}
          </h2>
        </div>
        <ChevronIcon className="collapse-icon" />
      </div>
      
      {filterTabs && !collapsed && filterTabs}
      
      {!collapsed && (
        <div className="section-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
